<template>
  <div class="calico-button-page">
    <div class="row">
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-primary">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-primary button-primary--small">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-primary button-primary--xsmall">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-primary button-primary-icon">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-primary button-primary-icon--small">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-primary button-primary-icon--xsmall">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button
            class="button-primary"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-primary button-primary--small"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-primary button-primary--xsmall"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-primary button-primary-icon"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-primary button-primary-icon--small"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-primary button-primary-icon--xsmall"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button class="button-primary">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-primary button-primary--small">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
      </div>
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-primary">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-primary button-primary--small">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-secondary">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary button-secondary--small">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary button-secondary--xsmall">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary button-secondary-icon">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary button-secondary-icon--small">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary button-secondary-icon--xsmall">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button
            class="button-secondary"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-secondary button-secondary--small"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-secondary button-secondary--xsmall"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-secondary button-secondary-icon"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-secondary button-secondary-icon--small"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-secondary button-secondary-icon--xsmall"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button class="button-secondary">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary button-secondary--small">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
      </div>
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-secondary">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary button-secondary--small">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>
    </div>

    <div class="row black-background">
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-secondary-alt">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary-alt button-secondary-alt--small">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary-alt button-secondary-alt--xsmall">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary-alt button-secondary-alt-icon">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary-alt button-secondary-alt-icon--small">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary-alt button-secondary-alt-icon--xsmall">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button
            class="button-secondary-alt"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-secondary-alt button-secondary-alt--small"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-secondary-alt button-secondary-alt--xsmall"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-secondary-alt button-secondary-alt-icon"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-secondary-alt button-secondary-alt-icon--small"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-secondary-alt button-secondary-alt-icon--xsmall"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button class="button-secondary-alt">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary-alt button-secondary-alt--small">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
      </div>
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-secondary-alt">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-secondary-alt button-secondary-alt--small">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-utility">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility button-utility--small">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility button-utility--xsmall">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility button-utility-icon">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility button-utility-icon--small">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility button-utility-icon--xsmall">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button
            class="button-utility"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-utility button-utility--small"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-utility button-utility--xsmall"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-utility button-utility-icon"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-utility button-utility-icon--small"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-utility button-utility-icon--xsmall"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button class="button-utility">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility button-utility--small">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
      </div>
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-utility">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility button-utility--small">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-utility-alt">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility-alt button-utility-alt--small">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility-alt button-utility-alt--xsmall">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility-alt button-utility-alt-icon">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility-alt button-utility-alt-icon--small">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility-alt button-utility-alt-icon--xsmall">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button
            class="button-utility-alt"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-utility-alt button-utility-alt--small"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-utility-alt button-utility-alt--xsmall"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-utility-alt button-utility-alt-icon"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-utility-alt button-utility-alt-icon--small"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-utility-alt button-utility-alt-icon--xsmall"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button class="button-utility-alt">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility-alt button-utility-alt--small">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
      </div>
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-utility-alt">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-utility-alt button-utility-alt--small">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-danger">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-danger button-danger--small">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-danger button-danger--xsmall">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-danger button-danger-icon">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-danger button-danger-icon--small">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-danger button-danger-icon--xsmall">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button
            class="button-danger"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-danger button-danger--small"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-danger button-danger--xsmall"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-danger button-danger-icon"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-danger button-danger-icon--small"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-danger button-danger-icon--xsmall"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button class="button-danger">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-danger button-danger--small">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
      </div>
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-danger">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-danger button-danger--small">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-tertiary">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-tertiary--small">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-tertiary-icon">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-tertiary-icon--small">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button
            class="button-tertiary"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-tertiary--small"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-tertiary-icon"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-tertiary-icon--small"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button class="button-tertiary">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-tertiary--small">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
      </div>
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-tertiary">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-tertiary--small">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>
    </div>

    <div class="row black-background">
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-tertiary-alt">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-tertiary-alt button-tertiary-alt--small">
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-tertiary-alt button-tertiary-alt-icon">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-tertiary-alt button-tertiary-alt-icon--small">
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button
            class="button-tertiary-alt"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-tertiary-alt button-tertiary-alt--small"
            disabled
          >
            Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-tertiary-alt button-tertiary-alt-icon"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button
            class="button-tertiary-alt button-tertiary-alt-icon--small"
            disabled
          >
            <i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>

      <div class="column">
        <div style="width: fit-content;">
          <button class="button-tertiary-alt">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-tertiary-alt button-tertiary-alt--small">
            <i class="bi bi-plus-lg" />Button
          </button>
        </div>
      </div>
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-tertiary-alt">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
        <div style="width: fit-content;">
          <button class="button-tertiary-alt button-tertiary-alt--small">
            Button<i class="bi bi-plus-lg" />
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column">
        <div style="width: fit-content;">
          <button class="button-link">
            example
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">

export default {
  name: 'CalicoButtonPage',
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
.calico-button-page {
  .column {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .row {
    display: flex;
    flex-direction: row;
    padding: 50px;
    gap: 20px;
  }

  .black-background{
    background: black;
  }
}
</style>
